import React from "react";
import { Globe } from "lucide-react";
import { useI18n } from "../contexts/I18nContext";

export default function LanguageSwitcher({ className = "" }) {
    const { lang, setLang } = useI18n();
    return (
        <button onClick={() => setLang(lang === "ro" ? "en" : "ro")}
                className={`flex items-center gap-1 text-xs uppercase font-medium hover:text-foreground ${className}`}
                data-testid="lang-switch" title={lang === "ro" ? "Switch to English" : "Schimbă în română"}>
            <Globe className="h-3 w-3" />
            <span>{lang === "ro" ? "RO" : "EN"}</span>
        </button>
    );
}
